import { render, staticRenderFns } from "./PadoCharSheetComponent.vue?vue&type=template&id=010feaca&scoped=true"
import script from "./PadoCharSheetComponent.vue?vue&type=script&lang=ts"
export * from "./PadoCharSheetComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoCharSheetComponent.vue?vue&type=style&index=0&id=010feaca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010feaca",
  null
  
)

export default component.exports